<template>
  <li>
    <button type="button" v-if="$user.isAdminOrCoordinator && routeIsJobRequests" @click="toggleJobPublic" class="public" :class="{ 'active': jobIsPublic }">
			<i class="fa fa-globe-asia"></i>
		</button>
    <div class="row">
      <div class="col-lg-9">
        <p class="rate" v-if="job.user"><span>{{ job.user.profile.company_name }}</span></p>
        <p v-if="job.commodity_and_location">
          {{ job.commodity_and_location_with_quantity }}
        </p>
        <p>Rate: {{ job.rate || '&ndash;' }}</p>
        <ul class="details">
          <li><span>Start Date:</span> {{ job.start_at || '&ndash;' }}</li>
          <li><span>End Date:</span> {{ job.end_at || '&ndash;' }}</li>
          <li><span>Notes:</span> <template v-if="job.notes">Yes</template><template v-else>No</template></li>
        </ul>
      </div>
      <div class="col-lg-3">
        <div class="btn-toolbar">
          <a @click="setActiveJob" data-toggle="modal" data-target=".modal-job-request" class="btn btn-info"><i class="fa fa-fw fa-map-marker-alt"></i></a>
          <ladda-button :on-click="handleDeclineRequest" ref="decline" class="btn btn-danger"><i class="fa fa-fw fa-times"></i></ladda-button>
          <ladda-button :on-click="handleAcceptRequest" ref="accept" class="btn btn-success"><i class="fa fa-fw fa-check"></i></ladda-button>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapMutations, mapActions } from 'vuex'
  import { SET_JOB, ADD_JOB } from 'vx/mutations'
  import { jobRequestActionsHelpers } from 'mixins/jobs'
  import { LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import $ from 'jquery'

  export default {
    props: ['job'],

    mixins: [jobRequestActionsHelpers],

    components: {
      LaddaButton
    },

    computed: {
      jobIsPublic () {
        return this.job.public
      },

      routeIsJobRequests () {
        return this.$route.name === 'jobs.requests'
      }
    },

    mounted () {
      setTimeout(this.automaticallyAcceptOrDecline, 500)
    },

    methods: {
      ...mapMutations('job', [SET_JOB, ADD_JOB]),
      ...mapActions('job', ['updateJob']),

      /**
       * Handle the toggling of the job being public.
       *
       * @return Promise
       */
      toggleJobPublic () {
        return this.updateJob({ id: this.job.id, payload: { user_id: this.job.user_id, public: !this.job.public } }).then(response => {
          this[ADD_JOB](response.data)
          if (response.data.public) {
            notify.success('Job is now public.')
          } else {
            notify.success('Job is no longer public.')
          }
        }).catch(error => {
          if (error.response.status === 403) {
            notify.error('Unable to modify completed job.')
          } else {
            notify.error('Error modifying job.')
          }
        })
      },

      /**
       * Automatically accept or decline a job.
       *
       * @return void
       */
      automaticallyAcceptOrDecline () {
        if (this.$route.name === 'jobs.requests.view' && parseInt(this.$route.params.id) === this.job.id && this.$route.params.action) {
          if (this.$refs[this.$route.params.action]) {
            $(this.$refs[this.$route.params.action].$el).trigger('click')
          }
        }
      },

      setActiveJob () {
        this[SET_JOB](this.job.decorated)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// JobRequestItem.vue?3a390302